import Prism from 'prismjs';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-python';

export default function initTerminalBlocks() {
    const preBlocks = document.querySelectorAll('pre');

    preBlocks.forEach((pre) => {
        // Add copy button
        const copyBtn = document.createElement('button');
        copyBtn.className = 'copy-button';
        copyBtn.textContent = 'COPY';

        copyBtn.addEventListener('click', () => {
            const code = pre.querySelector('code');
            if (code) {
                navigator.clipboard.writeText(code.innerText).then(() => {
                    copyBtn.textContent = 'COPIED!';
                    copyBtn.style.color = '#000';
                    copyBtn.style.background = 'var(--color-primary)';
                    setTimeout(() => {
                        copyBtn.textContent = 'COPY';
                        copyBtn.style.color = 'var(--color-primary)';
                        copyBtn.style.background = '#000';
                    }, 2000);
                });
            }
        });

        pre.appendChild(copyBtn);
    });

    // Run Prism highlighting
    Prism.highlightAll();
}
